const validate = (values) => {
  const  errors = {};

   if (!values.email) {

    errors.email={
      ar: "يجب ادخال البريد الاليكتروني",
      en: "Required"
    }
   } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.email)) {
    errors.email={
      ar: "البريد الالكتروني ليس صحيح",
      en: "Invalid Email"
    }
 
 
  }
 
 return errors
 
}

export default validate;
